import { dew as _listDew } from "./list";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.list = void 0;
  var list_1 = _listDew();
  Object.defineProperty(exports, "list", {
    enumerable: true,
    get: function () {
      return list_1.list;
    }
  });
  return exports;
}